// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_161_BD8L","page":"_2P5x2K7T","content":"B4nZX7qL","mobile-week-table":"_2inI1Uom","week-table":"TKe2FK_5"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/pages/WeeklyWorkoutPage/WeeklyWorkoutPage.styl
// module id = 529
// module chunks = 0